module.exports = __webpack_public_path__ + "static/media/connect-provider.bfd76955.png";